import { render, staticRenderFns } from "./AiQuotaSection.vue?vue&type=template&id=def5b16e&scoped=true&"
import script from "./AiQuotaSection.vue?vue&type=script&lang=js&"
export * from "./AiQuotaSection.vue?vue&type=script&lang=js&"
import style0 from "./AiQuotaSection.vue?vue&type=style&index=0&id=def5b16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5b16e",
  null
  
)

export default component.exports